import {
  FETCH_TOP_ACTIVE_JOBS_REQUEST,
  FETCH_TOP_ACTIVE_JOBS_SUCCESS,
  FETCH_TOP_ACTIVE_JOBS_FAILURE,
} from "../../actionTypes";

export const fetchTopActiveJobsRequest = (data) => ({
  type: FETCH_TOP_ACTIVE_JOBS_REQUEST,
  payload: data,
});

export const fetchTopActiveJobsSuccess = (data) => ({
  type: FETCH_TOP_ACTIVE_JOBS_SUCCESS,
  payload: data,
});

export const fetchTopActiveJobsFailure = (error) => ({
  type: FETCH_TOP_ACTIVE_JOBS_FAILURE,
  payload: error,
});


